import { render, staticRenderFns } from "./AnalyticsPatientsFilter.vue?vue&type=template&id=2d76c0ec"
import script from "./AnalyticsPatientsFilter.vue?vue&type=script&lang=js"
export * from "./AnalyticsPatientsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports